import { HallActionTypes, HallState } from "./types";
import { Reducer } from "redux";

const initialState: HallState = {
  halls: [],
  loading: false,
  error: null,
  isHallSubmitting: false,
  isHallDeleting: false,
  success: false,
  failure: false,
  deleteSuccess: false,
  page: "",
  floors: [],
  isFloorSubmitting: false,
  isFloorDeleting: false,
  rooms: [],
  isRoomSubmitting: false,
  isRoomDeleting: false,
  hall: null,
  floor: null,
  room: null,
};

const reducer: Reducer<HallState> = (state = initialState, action) => {
  switch (action.type) {
    case HallActionTypes.FETCH_HALLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallActionTypes.FETCH_HALLS_SUCCESS:
      return {
        ...state,
        loading: false,
        halls: action.payload,
      };
    case HallActionTypes.FETCH_HALLS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallActionTypes.FETCH_HALL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallActionTypes.FETCH_HALL_SUCCESS:
      return {
        ...state,
        loading: false,
        hall: action.payload,
      };
    case HallActionTypes.FETCH_HALL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallActionTypes.CREATE_HALL_REQUEST:
      return {
        ...state,
        isHallSubmitting: true,
        success: false,
        failure: false,
        error: null,
      };
    case HallActionTypes.CREATE_HALL_SUCCESS:
      return {
        ...state,
        isHallSubmitting: false,
        success: true,
        failure: false,
        halls: [...state.halls, action.payload],
      };
    case HallActionTypes.CREATE_HALL_ERROR:
      return {
        ...state,
        isHallSubmitting: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case HallActionTypes.UPDATE_HALL_REQUEST:
      return {
        ...state,
        isHallSubmitting: true,
        success: false,
        failure: false,
        error: null,
      };
    case HallActionTypes.UPDATE_HALL_SUCCESS:
      return {
        ...state,
        isHallSubmitting: false,
        success: true,
        failure: false,
        halls: state.halls.map((hall) =>
          hall.id === action.payload.id ? action.payload : hall
        ),
      };
    case HallActionTypes.UPDATE_HALL_ERROR:
      return {
        ...state,
        isHallSubmitting: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case HallActionTypes.DELETE_HALL_REQUEST:
      return {
        ...state,
        isHallDeleting: true,
        deleteSuccess: false,
        error: null,
      };
    case HallActionTypes.DELETE_HALL_SUCCESS:
      return {
        ...state,
        isHallDeleting: false,
        deleteSuccess: true,
        halls: state.halls.filter((hall) => hall.id !== action.payload),
      };
    case HallActionTypes.DELETE_HALL_ERROR:
      return {
        ...state,
        isHallDeleting: false,
        deleteSuccess: false,
        error: action.payload,
      };
    case HallActionTypes.FETCH_HALL_ROOMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case HallActionTypes.FETCH_HALL_ROOMS_SUCCESS:
      return {
        ...state,
        loading: false,
        rooms: action.payload,
      };
    case HallActionTypes.FETCH_HALL_ROOMS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case HallActionTypes.CLEAR_HALL_STATE:
      return {
        ...state,
        halls: [],
        loading: false,
        error: null,
        isHallSubmitting: false,
        isHallDeleting: false,
        success: false,
        failure: false,
        deleteSuccess: false,
        page: "",
        floors: [],
        isFloorSubmitting: false,
        isFloorDeleting: false,
        rooms: [],
        isRoomSubmitting: false,
        isRoomDeleting: false,
        hall: null,
        floor: null,
        room: null,
      };
    default:
      return state;
  }
};

export { reducer as HallReducer };
